require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-archive-grapevine.json") })
        }
      }, "path---projects-archive-grapevine");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-archive-grapevine!./.cache/json/projects-archive-grapevine.json
// module id = 357
// module chunks = 231608221292675